(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/game-limits-deposits-form/assets/javascripts/tracking.js') >= 0) return;  svs.modules.push('/components/accountservices-react/game-limits-deposits-form/assets/javascripts/tracking.js');

'use strict';

const eventActions = {
  CONFIRM: 'confirm',
  CANCEL: 'cancel'
};
const trackingAccept = actionType => {
  const track = {
    category: 'Deposit Limit',
    action: actionType
  };
  svs.components.analytics.trackEvent(track);
};
const trackingLimit = () => {
  const track = {
    category: 'Deposit Limit',
    action: 'set',
    opt_label: 'all'
  };
  svs.components.analytics.trackEvent(track);
};
svs.accountservicesReact.gameLimitDepositsForm.tracking = {
  trackingAccept,
  trackingLimit,
  eventActions
};

 })(window);